import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { getSubdomainPage } from "@/subdomains/pages";
import { getSubdomainConfig } from "@/subdomains/configs";
import SubdomainContactPage from "@/subdomains/SubdomainContactPage";

const slug = process.env.REACT_APP_SUBDOMAIN;

export default function SubdomainRoot() {
  const Page = slug ? getSubdomainPage(slug) : null;
  const config = slug ? getSubdomainConfig(slug) : null;

  if (!Page || !config) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <p className="text-zinc-600 text-center max-w-md px-6">
          Invalid subdomain build. Set REACT_APP_SUBDOMAIN to one of: leadscoring, metals, agriculture, mining, realty, aiservices, precast
        </p>
      </div>
    );
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Page />} />
          <Route path="/contact" element={<SubdomainContactPage config={config} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </>
  );
}
